/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/eolMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Eol. */
export class Eol {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Eol.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls FlightSetting to get public preview settings.
   * @summary Retrieves public preview settings.
   * @param [options] The optional parameters
   * @returns Promise<Models.EolGetPublicPreviewSettingsResponse>
   */
  getPublicPreviewSettings(options?: coreHttp.RequestOptionsBase): Promise<Models.EolGetPublicPreviewSettingsResponse>;
  /**
   * @param callback The callback
   */
  getPublicPreviewSettings(callback: coreHttp.ServiceCallback<Models.PublicPreviewSettings>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getPublicPreviewSettings(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.PublicPreviewSettings>): void;
  getPublicPreviewSettings(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.PublicPreviewSettings>, callback?: coreHttp.ServiceCallback<Models.PublicPreviewSettings>): Promise<Models.EolGetPublicPreviewSettingsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getPublicPreviewSettingsOperationSpec,
      callback) as Promise<Models.EolGetPublicPreviewSettingsResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getPublicPreviewSettingsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/preview/Eol",
  responses: {
    200: {
      bodyMapper: Mappers.PublicPreviewSettings
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
